import { render } from "./allServiceList.vue?vue&type=template&id=629b686a&scoped=true"
import script from "./allServiceList.vue?vue&type=script&lang=js"
export * from "./allServiceList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629b686a"]])

export default __exports__